import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { fetchPoFileObjectUrl, useRevokeObjectUrl } from "@/utils/poFileUrl";

const Message = ({ text }: { text: string }) => (
  <div className="flex items-center justify-center h-screen bg-background">
    <p className="text-muted-foreground">{text}</p>
  </div>
);

const ViewPurchaseOrder = () => {
  const [searchParams] = useSearchParams();
  const path = searchParams.get("path");
  const poId = searchParams.get("poId");
  const [fileUrl, setFileUrl] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);
  useRevokeObjectUrl(fileUrl);

  useEffect(() => {
    document.title = "Purchase Order - figabl";
  }, []);

  useEffect(() => {
    if (!path || !poId) return;
    let cancelled = false;
    setFileUrl(null);
    setFailed(false);
    fetchPoFileObjectUrl(poId, path)
      .then((url) => {
        if (cancelled) URL.revokeObjectURL(url);
        else setFileUrl(url);
      })
      .catch(() => { if (!cancelled) setFailed(true); });
    return () => { cancelled = true; };
  }, [path, poId]);

  if (!path || !poId) return <Message text="Missing file parameters" />;
  if (failed) return <Message text="This file is unavailable. Sign in with an account that can access it." />;
  if (!fileUrl) return <Message text="Loading file..." />;

  return (
    <div className="w-full h-screen">
      <iframe
        src={fileUrl}
        className="w-full h-full border-0"
        title="Purchase Order Document"
      />
    </div>
  );
};

export default ViewPurchaseOrder;
